import React, { Component } from 'react';
import Panel                from '../../../components';
import PropTypes            from 'prop-types';
import { connect } from "react-redux";

import {
  Row,
  Col,
  Button,
  FormGroup,
  FormControl,
  ControlLabel,
  Checkbox,
  HelpBlock,
  Alert
} from 'react-bootstrap';
import { createBrowserHistory } from 'history';

import { NewBreadcrumb as BreadcrumbComponent } from '../../../components';
import loader from '../../../style/loader/loader.scss';
import { withRouter, Link } from 'react-router-dom';
import {
  bindActionCreators,
  compose
}                     from 'redux';
import isEmpty from 'lodash.isempty';
import DateTimePicker from 'react-datetime-picker';
import moment from 'moment';

import FormValidator from '../../../_helpers/FormValidator';

import 'rc-color-picker/assets/index.css';
import ColorPicker from 'rc-color-picker';

import {changePassword}    from '../../../redux/actions/frontActions';
import {renderAlert,clearAlert, alertsActions} from '../../../redux/actions/alertsActions';
import {aclUtil} from "../../util"

const history = createBrowserHistory();

class AdminResetPassword extends React.Component  {
  static contextTypes = {
    router: PropTypes.object
  }
  constructor(props) {
    super(props);

    this.validator = new FormValidator([
      { 
        field: 'new_password', 
        method: 'isEmpty', 
        validWhen: false, 
        message: 'Password is required.'
      },
      { 
        field: 'new_password', 
        method: 'matches',
        args: [/^.{5,}$/],
        validWhen: true, 
        message: 'password required more than 5 characters.'
      },
      { 
        field: 'password_confirmation', 
        method: 'isEmpty', 
        validWhen: false, 
        message: 'Password confirmation is required.'
      },
      { 
        field: 'password_confirmation', 
        method: this.passwordMatch,   // notice that we are passing a custom function here
        validWhen: true, 
        message: 'Password and password confirmation do not match.'
      }
    ]);

    const editLink = props.match.params.userId && `addSubAdmin/${props.match.params.userId}` 
    this.state = {
      menuKey: 'CHANGE_PASSWORD',
      path: ['Home', 'Manually Set Password'], 
      links:['home',editLink],
      new_password: '',
      password_confirmation: '',
      msg_status: 'hide',
      alertMessage:'',
      show: false,
      msgType: '',
      loading:false,
      message: '',
      userId: "",
      validation: this.validator.valid(),
    };

    this.handleInputChange=this.handleInputChange.bind(this);

    this.submitted = false;
  }

  passwordMatch = (confPwd, state) => {

    if(confPwd !== state.new_password)
    {
      return false;
    }
    else
    {
      return true
    }
  }


  handleInputChange = event => {
    this.setState({
      [event.target.name]: event.target.value,
    });
  }
  

  componentDidMount() {
    if(this.props.match && this.props.match.params.userId){
      this.setState({userId: this.props.match.params.userId});
    }
  }

  componentWillReceiveProps(nextProps) {
    if(!aclUtil.isPrimaryMenuAccessible(this.state.menuKey)){
      this.context.router.history.push("/restrictedAccess");
    }

    if(this.props.passwordStatus !== nextProps.passwordStatus){
      this.setState({
        msgType: nextProps.passwordStatus.response,
        message: nextProps.passwordStatus.message,
        loading:false
      });
      setTimeout(
      function() {
          this.setState({
            msgType: '',
            message: ''
          });
      }
      .bind(this),
      4000
    );
    }
    if(nextProps.error)
    {
      this.setState({
        msgType: 'error',
        message: nextProps.error,
        loading:false
      });
      setTimeout(
      function() {
          this.setState({
            msgType: '',
            message: ''
          });
      }
      .bind(this),
      4000
    );
    }
  }

  handleFormSubmit = event => {
    event.preventDefault();
    const validation = this.validator.validate(this.state);
    this.setState({ validation });
    this.submitted = true;
    
    if (validation.isValid) {
      // handle actual form submission here
      this.setState({
        loading:true
      });
      const formData = {
        password : this.state.new_password,
        userID : this.state.userId
      };
      
      const { actions : {changePassword}} = this.props;
      changePassword(formData);
    }
    else
    {
      this.setState({
        loading:false
      });
    }
  }

  handleselectedFile = event => {
    this.setState({
      display_image: event.target.files[0]
    })
  }

  handleColorChange = event => {
    this.setState({
      'background_color': event.color
    });

  }

  renderAlert(){
    if(this.state.msgType && this.state.message) {
      let msgClass = (this.state.msgType=='error') ? 'alert alert-danger' : 'alert alert-'+this.state.msgType;
      return(
        <div className={msgClass}>
          <strong>{this.state.msgType.toUpperCase()} :</strong> {this.state.message}
        </div>
      )
    }
  }

  render() {
    let validation = this.submitted ?                         // if the form has been submitted at least once
                      this.validator.validate(this.state) :   // then check validity every time we render
                      this.state.validation                   // otherwise just use what's in state
    let {userId} = this.state;
    return (
      <div className="col-lg-12 add-sub-admin">
        {(this.state.loading === true) ?
          <div className="loader">
            <p className="loading-message">
            <i>
                Loading...
            </i>
            </p>
            <div className="spinner">
                <div className="dot1"></div>
                <div className="dot2"></div>
            </div>
          </div> : ''
        }

        <form>
          {this.renderAlert()}
          <div className="row">
            <div className="col-xs-12">
              <BreadcrumbComponent path={this.state.path} links={this.state.links} context={this.context}/>
            </div>
          </div>
      
          <div className="panel">
            <header className="panel-heading">Manually Set Password
            </header>
        
            {this.state.show && this.state.alertMessage !=='' &&        
              <div className="col-lg-12">
                <Alert bsStyle={this.state.msgType} onDismiss={this.handleDismiss}>
                  <strong>{this.state.msgType}:</strong> {this.state.alertMessage}
                </Alert>
              </div>
            } 
       
            <div className="panel-body">
              <div className="add-city col-lg-12 col-md-12 col-sm-12 col-xs-12">
                <Row>
                  <Col md={8} xs={12} mdOffset={2}>
                    <FormGroup controlId="formNewPasswordText" className={(validation.new_password.isInvalid) && 'has-error'}>
                      <ControlLabel>
                        <span style={{ color: "red" }}>*</span> New Password
                      </ControlLabel>
                      <FormControl
                        type="password"
                        value={this.state.new_password}
                        placeholder="Enter Password"
                        onChange={this.handleInputChange}
                        name="new_password"
                      />
                      <span className="help-block">{validation.new_password.message}</span>
                    </FormGroup>
                    
                    <FormGroup controlId="formConfirmPasswordText" className={(validation.password_confirmation.isInvalid) && 'has-error'}>
                      <ControlLabel>
                        <span style={{ color: "red" }}>*</span> Confirm Password
                      </ControlLabel>
                      <FormControl
                        type="password"
                        value={this.state.password_confirmation}
                        placeholder="Enter Confirm Password"
                        onChange={this.handleInputChange}
                        name="password_confirmation"
                      />
                      <span className="help-block">{validation.password_confirmation.message}</span>
                    </FormGroup>
                  </Col>
                </Row>              
              </div>
            </div>
          </div>
          <Row className="BtnRow">
            <Col md={12} xs={12}>
              <Button bsStyle="info" type="button" onClick={this.handleFormSubmit} id="saveButton" disabled={this.props.loading} >Update Password</Button>
              <Button bsStyle="default" onClick={() => this.context.router.history.push(`/addSubAdmin/${userId}`)}>Cancel</Button>
            </Col>
          </Row>
        </form>
      </div>
    )
  }
};

const mapStateToProps = (state) => {
  return {
    error: state.frontReducer.error,
    passwordStatus: state.frontReducer.passwordStatus,
    alertType: state.alertsReducer.alertType,
    message: state.alertsReducer.message,
    loading: state.frontReducer.sending,
  };
};


const mapDispatchToProps = (dispatch) => {
  return {
    actions : bindActionCreators(
      {
        changePassword,
        ...alertsActions
      },
      dispatch)
  };
};

export default withRouter(connect(
  mapStateToProps,
  mapDispatchToProps
)(AdminResetPassword));



// WEBPACK FOOTER //
// ./src/app/views/admin/subAdmin/AdminResetPassword.js